import { Button, Col, Flex, Form, Image, Input, Modal, Row, Select, TimePicker, Tooltip } from 'antd';
import { Rule } from 'antd/es/form';
import { SelectProps } from 'antd/lib';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import iconDelete from '../../../assets/images/schedules/icon-delete-segment.svg';
import iconPlus from '../../../assets/images/schedules/icon-plus.svg';
import { TimeFormat } from '../../../config/constant';
import { calculateTimeSum } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchListDistrict } from '../../../redux/slice/provinceSlice';
import { setListSegment, setResetLoadSchedule } from '../../../redux/slice/schdules/scheduleSlice';
import '../../schedules/Schedules.scss';

const SegmentSettingModal: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  loading,
  isActive,
  routeActive,
  isDetailSchedule,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [formSegments] = Form.useForm();
  const { listProvince, listSegment } = useAppSelector((state) => state.listSchedule);
  const { district } = useAppSelector((state) => state?.province);
  const travelPattern = /^\d{1,2}:(?:[0-5][0-9]|59)$/;
  const dispatch = useAppDispatch();

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    formSegments.resetFields();
    onCancel();
  };
  const filterOption = (
    input: string,
    option?: {
      label?: any;
      value?: any;
    },
  ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  const provinceRules: Rule[] = [
    {
      required: true,
      message: t('Vui lòng chọn tỉnh / thành phố'),
    },
  ];
  const handleChangeWard = (value: any, option: any, index: number) => {
    formSegments.setFieldValue(['segment', index, 'district_name'], option?.label);
  };
  const handleClickDistrict = (index: number) => {
    const provinceId = formSegments.getFieldValue(['segment', index, 'province_id']);
    if (provinceId) {
      dispatch(fetchListDistrict({ province_id: provinceId }));
    }
  };
  const handleChangeProvince = (value: any, option: any, index: number) => {
    dispatch(fetchListDistrict({ province_id: value }));
    formSegments.setFieldValue(['segment', index, 'district_id'], undefined);
    formSegments.setFieldValue(['segment', index, 'district_name'], undefined);
    let processedLabel = option?.label;
    if (processedLabel.startsWith('Tỉnh ')) {
      processedLabel = processedLabel.replace('Tỉnh ', '');
    } else if (processedLabel.startsWith('Thành phố ')) {
      processedLabel = processedLabel.replace('Thành phố ', '');
    }
    formSegments.setFieldValue(['segment', index, 'name'], processedLabel);
    formSegments.validateFields([['segment', index, 'name']]);
  };
  const provincesOption: SelectProps['options'] = listProvince?.length
    ? listProvince?.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
        };
      })
    : [];
  const districtOption: SelectProps['options'] = district?.length
    ? district?.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
        };
      })
    : [];
  const updateArriveTime = (values: any) => {
    const timePattern = /^([0-9]{1,}|[01]?[0-9]|2[0-4]):([0-5][0-9])$/;
    const travelTime = formSegments.getFieldValue('travel_time');
    const departTimeValue = dayjs(formSegments.getFieldValue('depart_time')).format('HH:mm');
    const departTimeNumber = departTimeValue?.replace(/:/g, '');
    if (Number(departTimeNumber) <= 2359) {
      if (timePattern.test(departTimeValue) && travelPattern.test(travelTime)) {
        const formSegmentsattedTravelTime = travelTime;
        if (formSegmentsattedTravelTime !== '00:00') {
          return formSegments.setFieldsValue({
            arrive_time: calculateTimeSum(formSegmentsattedTravelTime, departTimeValue),
          });
        }
      }
    }
  };
  const onFinish = (values: any) => {
    values.depart_time = dayjs(values.depart_time).format(TimeFormat);
    const departTime = dayjs(values.depart_time, TimeFormat);
    const [travelHours, travelMinutes] = values.travel_time?.split(':')?.map(Number);
    const arrivalTime = departTime.add(travelHours, 'hour')?.add(travelMinutes, 'minute');
    const diffDay = arrivalTime?.startOf('day')?.diff(departTime?.startOf('day'), 'days');
    const formattedSegments = values?.segment?.length
      ? values.segment
          ?.map((segmentItem: any) => ({
            ...segmentItem,
            arrive_time: dayjs(segmentItem.arrive_time).format(TimeFormat),
          }))
          ?.sort((a: any, b: any) => {
            if (a.diff_day !== b.diff_day) {
              return a.diff_day - b.diff_day;
            }
            return dayjs(a.arrive_time, TimeFormat).isBefore(dayjs(b.arrive_time, TimeFormat)) ? -1 : 1;
          })
          ?.map((segmentItem: any, sortedIndex: number) => ({
            ...segmentItem,
            no: sortedIndex + 2,
          }))
      : [];
    const newSegment = [
      {
        no: 1,
        arrive_time: values.depart_time,
        diff_day: 0,
        district_id: undefined,
        name: values.depart_point,
        province_id: values.depart_id,
        country_id: 1,
      },
      ...formattedSegments,
      {
        no: values.segment?.length + 2,
        arrive_time: values.arrive_time,
        diff_day: diffDay ? diffDay : 0,
        district_id: undefined,
        name: values.arrive_point,
        province_id: values.arrive_id,
        country_id: 1,
      },
    ];
    const oldSegment = [
      {
        no: 1,
        arrive_time: values.depart_time,
        diff_day: 0,
        district_id: undefined,
        name: values.depart_point,
        province_id: values.depart_id,
        country_id: 1,
      },
      {
        no: 2,
        arrive_time: values.arrive_time,
        diff_day: 0,
        district_id: undefined,
        name: values.arrive_point,
        province_id: values.arrive_id,
        country_id: 1,
      },
    ];
    values.segment = values?.segment?.length > 0 ? newSegment : oldSegment;
    dispatch(setListSegment(values));
    modalHandleCancel();
  };
  useEffect(() => {
    if (isActive && !listSegment?.depart_id && !listSegment?.arrive_id) {
      formSegments.setFieldsValue({
        arrive_point: routeActive?.arrive_point,
        arrive_id: routeActive?.arrive_province?.id,
        depart_point: routeActive?.depart_point,
        depart_id: routeActive?.depart_province?.id,
      });
    }
    if (
      isActive &&
      routeActive?.depart_point &&
      routeActive?.arrive_point &&
      listSegment?.depart_id &&
      listSegment?.arrive_id &&
      (routeActive?.depart_point !== listSegment?.depart_point ||
        routeActive?.arrive_point !== listSegment?.arrive_point)
    ) {
      dispatch(setResetLoadSchedule());
      formSegments.resetFields();
    }
  }, [isActive, routeActive, listSegment, isModalOpen]);

  useEffect(() => {
    if (!!(listSegment?.depart_id || listSegment?.arrive_id)) {
      const newSegmentItem = listSegment?.segment?.filter(
        (segment: any) => segment?.name !== listSegment?.arrive_point && segment?.name !== listSegment?.depart_point,
      );
      const dispatchedProvinceIds = new Set();
      formSegments.setFieldsValue({
        arrive_point: listSegment?.arrive_point,
        travel_time: listSegment?.travel_time,
        depart_time: dayjs(listSegment?.depart_time, TimeFormat),
        arrive_id: listSegment?.arrive_id,
        depart_point: listSegment?.depart_point,
        depart_id: listSegment?.depart_id,
        arrive_time: listSegment?.arrive_time,
        segment: newSegmentItem?.map((segmentItem: any) => {
          if (isActive && !dispatchedProvinceIds.has(segmentItem?.province_id)) {
            dispatch(fetchListDistrict({ province_id: segmentItem?.province_id }));
            dispatchedProvinceIds.add(segmentItem?.province_id);
          }
          return {
            ...segmentItem,
            name: segmentItem?.name,
            province_id: segmentItem?.province_id,
            district_id: segmentItem?.district_id,
            arrive_time: dayjs(segmentItem.arrive_time, TimeFormat),
            diff_day: segmentItem?.diff_day,
          };
        }),
      });
    }
  }, [listSegment, formSegments, isModalOpen]);
  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      maskClosable={false}
      centered
      width={1300}
      footer={
        <>
          <Row className="d-flex justify-content-end mt-5">
            <Button
              loading={loading}
              key="cancel"
              className="  w-160 h-btn-48 me-3"
              onClick={() => modalHandleCancel()}
            >
              Đóng
            </Button>

            <Button
              key="submit"
              type="primary"
              loading={loading}
              className="w-160 h-btn-48 btn-success mr-0"
              htmlType="submit"
              onClick={formSegments.submit}
            >
              Lưu
            </Button>
          </Row>
        </>
      }
      className="modal-segment-block"
      styles={{ body: { maxHeight: '650px', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '30px' } }}
    >
      <Flex className="segment-header">
        <h5 className="fw-600 fs-18 title">Thiết lập chặng</h5>
      </Flex>
      <Form
        name="segment-setting-form"
        layout="vertical"
        form={formSegments}
        onFinish={onFinish}
        colon={false}
        validateTrigger="onSubmit"
        initialValues={{
          depart_time: dayjs().startOf('day').hour(0).minute(0),
          arrive_time: '00:00',
          travel_time: '00:00',
        }}
      >
        <div className="border-b">
          <Row gutter={8} className="mt-4 block-segment-item ">
            <Col span={4}>
              <Form.Item name="depart_point" className="form-input">
                <Input disabled placeholder="Điểm đón" />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item name="depart_id">
                <Select
                  className="input-h36"
                  showSearch
                  // filterOption={filterOption}
                  placeholder="Chọn tỉnh / thành phố"
                  size="large"
                  style={{ width: '100%' }}
                  disabled
                  options={provincesOption}
                />
              </Form.Item>
            </Col>
            <Col span={4} className="time-schedule-block">
              <Form.Item
                name={'depart_time'}
                className="form-item-name form-item__pickup_time--depart required pickup-time"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập giờ đi',
                  },
                ]}
              >
                <TimePicker
                  suffixIcon={null}
                  showNow={false}
                  needConfirm={false}
                  format={'HH:mm'}
                  placeholder="00:00"
                  onChange={updateArriveTime}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                name="travel_time"
                className="form-item-name required time-sum"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if ((value && value === '00:00') || !value) {
                        return Promise.reject(new Error('Vui lòng nhập tổng thời gian'));
                      }
                      if (!travelPattern.test(value)) {
                        return Promise.reject(new Error('Vui lòng nhập đúng định dạng 00:00'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder="00:00" onChange={updateArriveTime} prefix={'Tổng thời gian'} />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="mt-3 border-b">
          <Form.List name={`segment`}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => {
                  return (
                    <div key={key}>
                      <Row gutter={8} className="mt-3 block-segment-item">
                        <Col span={4}>
                          <Form.Item
                            {...restField}
                            name={[name, 'name']}
                            className="input-seat form-input"
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng nhập điểm dừng',
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const allName = getFieldValue(['segment']).map((item: any) => item.name);
                                  const nameDepart = formSegments.getFieldValue('depart_point');
                                  const nameArrive = formSegments.getFieldValue('arrive_point');
                                  const duplicate =
                                    allName?.length &&
                                    (allName?.filter((loc: any) => loc?.length > 0 && loc === value)?.length > 1 ||
                                      allName?.filter(
                                        (loc: any) => loc?.length > 0 && (loc === nameDepart || loc === nameArrive),
                                      )?.length > 0);
                                  if (duplicate) {
                                    return Promise.reject(new Error('Điểm dừng đã được chọn'));
                                  }
                                  return Promise.resolve();
                                },
                              }),
                            ]}
                          >
                            <Input placeholder="Nhập điểm dừng" />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: '15%' }}>
                          <Form.Item {...restField} name={[name, 'country_id']} className="form-item-name">
                            <Select
                              className="input-h36"
                              showSearch
                              filterOption={filterOption}
                              placeholder="Chọn quốc gia"
                              size="large"
                              style={{ width: '100%' }}
                              options={[{ value: 1, label: 'Việt Nam' }]}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: '18%' }}>
                          <Form.Item
                            {...restField}
                            name={[name, 'province_id']}
                            className="form-item-name required"
                            validateTrigger={['onChange', 'onBlur']}
                            rules={provinceRules}
                          >
                            <Select
                              className="input-h36"
                              showSearch
                              filterOption={filterOption}
                              placeholder="Chọn tỉnh / thành phố"
                              size="large"
                              style={{ width: '100%' }}
                              options={provincesOption}
                              onChange={(value: any, option: any) => handleChangeProvince(value, option, index)}
                            />
                          </Form.Item>
                        </Col>
                        <Form.Item {...restField} name={[name, 'district_name']} className="d-none">
                          <Input />
                        </Form.Item>
                        <Col span={4}>
                          <Form.Item
                            {...restField}
                            name={[name, 'district_id']}
                            className="form-item-name required"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Select
                              className="input-h36"
                              showSearch
                              filterOption={filterOption}
                              placeholder="Chọn quận / huyện"
                              size="large"
                              style={{ width: '100%' }}
                              options={districtOption}
                              onChange={(value: any, option: any) => handleChangeWard(value, option.label, index)}
                              onClick={() => handleClickDistrict(index)}
                              value={formSegments.getFieldValue(['segment', index, 'district_id'])}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4} className="time-schedule-block">
                          <Form.Item
                            {...restField}
                            name={[name, 'arrive_time']}
                            className="form-item-name form-item__pickup_time--arrive required pickup-time"
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng nhập giờ đến',
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (!value) {
                                    return Promise.resolve();
                                  }
                                  const allSegments = getFieldValue('segment') || [];
                                  const currentDiffDay = getFieldValue(['segment', name, 'diff_day']);
                                  const isDuplicate = allSegments.some(
                                    (item: any, index: number) =>
                                      index !== name &&
                                      item.arrive_time?.format('HH:mm') === value.format('HH:mm') &&
                                      item.diff_day === currentDiffDay,
                                  );

                                  if (isDuplicate) {
                                    return Promise.reject(new Error('Giờ đến không được trùng nhau'));
                                  }

                                  return Promise.resolve();
                                },
                              }),
                            ]}
                            validateTrigger={['onChange', 'onBlur', 'onSubmit']}
                          >
                            <TimePicker
                              suffixIcon={null}
                              showNow={false}
                              needConfirm={false}
                              format={'HH:mm'}
                              placeholder="00:00"
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: '140px' }}>
                          <Form.Item
                            {...restField}
                            name={[name, 'diff_day']}
                            className="form-item-name form-item__diff_day required diff-day"
                            initialValue={0}
                          >
                            <Select
                              options={[
                                { value: 0, label: 'Trong ngày' },
                                { value: 1, label: '1 ngày sau' },
                                { value: 2, label: '2 ngày sau' },
                              ]}
                              onChange={(value) => {
                                formSegments.setFields([
                                  {
                                    name: ['segment', name, 'arrive_time'],
                                    errors: [],
                                  },
                                ]);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ height: '40px' }} span={1}>
                          <Tooltip title="Xóa">
                            <Button type="text" onClick={() => remove(name)} className="p-0 btn-delete-segment">
                              <Image src={iconDelete} preview={false} />
                            </Button>
                          </Tooltip>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
                <Button
                  htmlType="button"
                  onClick={() => {
                    if (fields?.length > 18) {
                      toast.error('Chỉ có thể nhập tối đa 20 chặng');
                    } else {
                      add({ country_id: 1 });
                    }
                  }}
                  className="border-none text-success gap-x-8 d-flex items-center mt-2"
                  style={{ paddingLeft: 0 }}
                >
                  Thêm điểm dừng
                  <img src={iconPlus} alt="" />
                </Button>
              </>
            )}
          </Form.List>
        </div>
        <Row gutter={8} className="mt-4 block-segment-item ">
          <Col span={4}>
            <Form.Item name="arrive_point" className="form-input">
              <Input disabled placeholder="Điểm trả" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item name="arrive_id">
              <Select
                className="input-h36"
                showSearch
                placeholder="Chọn tỉnh / thành phố"
                size="large"
                style={{ width: '100%' }}
                disabled
                options={provincesOption}
              />
            </Form.Item>
          </Col>
          <Col span={4} className="time-schedule-block">
            <Form.Item name={'arrive_time'} className="form-item-name arrive arrive-time time-sum disabled">
              <Input disabled prefix={'Giờ đến'} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SegmentSettingModal;
